// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as PlaceOrderStore from "../../app/state-machine/PlaceOrderStore.bs.js";
import * as PlaceOrderContextProvider from "./PlaceOrderContextProvider.bs.js";

function PlaceOrderDataProviderHOC(Props) {
  var children = Props.children;
  var updatedInitialState = Props.updatedInitialState;
  var match = React.useReducer(PlaceOrderStore.reducer, updatedInitialState);
  var dispatch = match[1];
  return React.createElement(PlaceOrderContextProvider.make, PlaceOrderContextProvider.makeProps({
                  state: match[0],
                  dispatch: Curry.__1(dispatch)
                }, children, undefined));
}

var make = PlaceOrderDataProviderHOC;

export {
  make ,
  
}
/* react Not a pure module */
